/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import ipRegex from 'ip-regex';
import {
  AlarmNotificationProfile,
  AdaptedAlarmNotificationProfile,
  AlarmsDef,
  AlarmsInst,
  InterceptAlarm
} from 'data/alarmNotificationProfile/alarmNotificationProfile.types';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';

export type ListenersIpAddressPortsType = {
  [key: string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view' | 'copy',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.alarmNtfyProfileId.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.profile_type.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.name.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptAlarmNotificationProfileData(
  alarmNotificationProfile: AlarmNotificationProfile,
): AdaptedAlarmNotificationProfile {
  const clonedAlarmNotificationProfile: AdaptedAlarmNotificationProfile = {
    alarmNtfyProfileId: alarmNotificationProfile.alarmNtfyProfileId,
    name: alarmNotificationProfile.name,
    email: extractEmailFromFormData(alarmNotificationProfile),
    profile_type: alarmNotificationProfile.profile_type,
    last_mailing_time: alarmNotificationProfile.last_mailing_time,
    frequency: alarmNotificationProfile.frequency,
    alarmsDef: extractAlarmDefFromFormData(alarmNotificationProfile),
    alarmsInst: extractAlarmInstFromFormData(alarmNotificationProfile),
    interceptAlarm: extractAlarmInterceptFromFormData(alarmNotificationProfile),
  };
  return clonedAlarmNotificationProfile;
}

export function extractEmailFromFormData(alarmNotificationProfile: AlarmNotificationProfile): string[] {
  return alarmNotificationProfile.email? alarmNotificationProfile.email.split(',') : [];
}

export function extractAlarmDefFromFormData(alarmNotificationProfile: AlarmNotificationProfile): AlarmsDef[] {
  const alarmDefData = alarmNotificationProfile.alarm_definition? alarmNotificationProfile.alarm_definition.split(',') : [];
  return alarmDefData.map((item) => {
    const alarmDef : AlarmsDef = {
      id: item,
      alarmId: item
    }
    return alarmDef;
  })
}

export function extractAlarmInstFromFormData(alarmNotificationProfile: AlarmNotificationProfile): AlarmsInst[] {
  const alarmInstData = alarmNotificationProfile.alarm_instance? alarmNotificationProfile.alarm_instance.split(',') : [];
  return alarmInstData.map((alarmInstanceValue) => {
    const valueList = alarmInstanceValue.split('|')
    const alarmInst : AlarmsInst = {
      id: alarmInstanceValue,
      alarmid: valueList[0],
      instance: valueList[1]
    }
    return alarmInst;
  })
}

export function extractAlarmInterceptFromFormData(alarmNotificationProfile: AlarmNotificationProfile): InterceptAlarm[] {
  const interceptData = alarmNotificationProfile.survindex? alarmNotificationProfile.survindex.split(',') : [];
  return interceptData.map((survindex) => {
    const interceptAlarm : InterceptAlarm = {
      id: survindex,
      survIndex: survindex
    }
    return interceptAlarm;
  })
}

export function addIdToAlarmDef(gridDataFields: string[], gridData?: any[]) {
  let clonedGridData = cloneDeep(gridData) || [];

  clonedGridData = clonedGridData?.map((row) => {
    const idValue = gridDataFields.reduce((finalString, item, index) => {
      return index === 0 ? row[item]?.toString() : `${finalString}+${row[item]?.toString()}`
    }, '')
    return { ...row, id: idValue }
  });

  return clonedGridData;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}
